$(document).ready(function() {
setInterval(function() {
  var currentURL = window.location.href;
  var targetURL = "https://ggs-nc.com/en/blogs/ggs-magazine?blog=alle-artikel";  
  if (currentURL === targetURL) {
    $('.all_blog .reactive').css('display', 'block');
  } else {
    $('.all_blog .reactive').css('display', 'none');
  }
}, 100);



  $(".mobile-language .disclosure ").click(function(){
      $(this).find(".disclosure__list-wrapper").toggle();
  });
});
